/**
 * retirementPlanningTabs.js — tab identifiers for RetirementPlanning.jsx, split
 * into their own zero-dependency module so external callers (PlanViewer.jsx)
 * can import them without a static import defeating the `lazy()` code-split
 * of the (heavy) RetirementPlanning component.
 */

// מזהי טאב סמנטיים — לא תלויי-מיקום, כדי שסדר התצוגה (מערך TABS ב-
// RetirementPlanning.jsx) יהיה ניתן לשינוי בלי לגעת בשום בדיקת tab === X.
export const TAB = {
  ME: "me", PARTNER: "partner", SEVERANCE: "severance", PENSIONS: "pensions",
  EXPENSES: "expenses", ASSUMPTIONS: "assumptions", PROJECTION: "projection",
};

// מיפוי היסטורי בלבד — הסדר המספרי הישן (לפני שילוב מזהים סמנטיים), לצורך
// מיגרציה שקופה של tabNotes שנשמרו בתכניות קיימות (מפתחות "0"-"6"). לא תלוי
// בסדר החדש של TABS ולכן לא משתנה גם אם TABS יסודר מחדש שוב בעתיד.
const LEGACY_TAB_INDEX = [TAB.SEVERANCE, TAB.PENSIONS, TAB.ME, TAB.PARTNER, TAB.EXPENSES, TAB.ASSUMPTIONS, TAB.PROJECTION];

export function migrateTabNotes(notes) {
  if (!notes) return {};
  const out = {};
  for (const [k, v] of Object.entries(notes)) {
    const legacyId = !isNaN(k) ? LEGACY_TAB_INDEX[parseInt(k, 10)] : null;
    out[legacyId || k] = v;
  }
  return out;
}
